module.exports = __webpack_public_path__ + "static/media/jt_bg_1.4fbb7ce2.jpg";